// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".aec6af2ebe3c344b9dcccc6cec6a70b7.js";
};